import * as Sentry from '@sentry/react';

const setSentryTags = (props: any): void => {
  try {
    Object.keys(props).forEach(key => {
      Sentry.setTag(key, props[key]);
    });
  } catch {}
};

export { setSentryTags };
